import { render, staticRenderFns } from "./DocsTable.vue?vue&type=template&id=4be87142"
import script from "./DocsTable.vue?vue&type=script&lang=ts"
export * from "./DocsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports